import React, { useState, useEffect, useContext, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Icon5 from '../../assest/images//Icon5.png';
import add from '../../assest/images/add.png'
import CustomDropdown from '../common/CustomDropdown';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import { BsPersonBadge } from "react-icons/bs";
import { Modal } from 'react-bootstrap';
import { AiOutlineInfoCircle } from "react-icons/ai";
import { MdPlaylistAdd } from "react-icons/md";
import PhoneInput from 'react-phone-input-2';
import CustomSingleValue from '../common/CustomSingleValue';

const ShipmentForm = () => {
  const { handleSubmit, reset } = useForm();
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSelectOpen, setIsSelectOpen] = useState(null);
  const [shipmentType] = useState('New Order');
  const [shipmentStatus, setShipmentStatus] = useState('Created');
  const [logisticPartyOptions, setLogisticPartyOptions] = useState([]);
  const [vehicleNumbers, setVehicleNumbers] = useState([]);
  const [routingNames, setRoutingNames] = useState([]);
  const [scpNames, setScpNames] = useState([]);
  const [orderNumbers, setOrderNumbers] = useState([]);
  const [comment, setComment] = useState('');
  const [selectedOrder, setSelectedOrder] = useState('');
  const [selectedOrderId, setSelectedOrderId] = useState('');
  const [selectedScpNameForOrder, setSelectedScpNameForOrder] = useState('');
  const [selectedScpIdForOrder, setSelectedScpIdForOrder] = useState('');

  const [scpName, setSCPName] = useState('');
  const [shipmentCode, setShipmentCode] = useState('');
  const [vehicleNumberDisabled, setVehicleNumberDisabled] = useState(true);
  const [scpNameDisabled, setScpNameDisabled] = useState(true);
  const [orderNumberDisabled, setOrderNumberDisabled] = useState(true);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedLogisticParty, setSelectedLogisticParty] = useState('');
  const [selectedRouting, setSelectedRouting] = useState('');
  const [selectedScpName, setSelectedScpName] = useState('');
  const [selectedVehicleNumber, setSelectedVehicleNumber] = useState('');

  const [logisticPartyEmpty, setLogisticPartyEmpty] = useState(false);
  const [vehicleNumberEmpty, setVehicleNumberEmpty] = useState(false);
  const [scanningModeEmpty, setScanningModeEmpty] = useState(false);
  const [routenameempty, setRoutenameempty] = useState(false);
  const [scpnameempty, setScpnameempty] = useState(false);
  const [ordernoempty, setOrdernoempty] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showconfimationModal, setshowconfimationModal] = useState(false);
  const [modalSelectedDate, setModalSelectedDate] = useState(selectedDate);

  const [showDriverModal, setShowDriverModal] = useState(false);
  const [driverName, setDriverName] = useState("");
  const [driverContact, setDriverContact] = useState("");

  const [selectedVehicleDimension, setSelectedVehicleDimension] = useState('');
  const [pendingDriverName, setPendingDriverName] = useState('');
  const [pendingDriverContact, setPendingDriverContact] = useState('');
  const [isScanningModeDisabled, setIsScanningModeDisabled] = useState(false);
  const [pendingShipmentCode, setPendingShipmentCode] = useState(null);

  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };


  // Define initial state for tableData, and load from local storage if available
  const [tableData, setTableData] = useState(() => {
    const storedData = sessionStorage.getItem('tableData');
    console.log("storedData", storedData)
    return storedData ? JSON.parse(storedData) : [];
  });

  const scanningModeOptions = [
    { id: '1', label: 'Vendor' },
    { id: '2', label: 'Product' }
  ];

  const logisticPartySelectOptions = logisticPartyOptions.map(option => ({
    value: String(option.LGCM_ID),
    label: option.LGCM_Name
  }));

  const [driverErrors, setDriverErrors] = useState({
    name: false,
    contact: false,
    message: ''
  });

  const phoneNumberToCountryCode = (dialCode) => {
    dialCode = String(dialCode); // 👈 Fix here
    switch (dialCode) {
      case '91': return 'in';
      case '1': return 'us';
      case '93': return 'af';
      case '213': return 'dz';
      case '61': return 'au';
      case '43': return 'at';
      case '32': return 'be';
      default: return undefined;
    }
  };
  const [phoneNumberCountry, setPhoneNumberCountry] = useState('91');
  const prevCountryRef = useRef(phoneNumberCountry || "91");
  const [resetCounter, setResetCounter] = useState(0);
  const allowedCountries = ['in', 'us', 'af', 'dz', 'au', 'at', 'be'];
  const phoneLengthMapping = {
    "91": 10, // India
    "1": 10,  // USA / Canada
    "44": 10, // UK
    "971": 9, // UAE
    "966": 9, // Saudi
    "61": 9,  // Australia
  };





  // States to track whether fields are enabled or disabled
  const [isLogisticPartySelected, setIsLogisticPartySelected] = useState(false);
  const [isRoutingSelected, setIsRoutingSelected] = useState(false);
  const [isScpNameSelected, setIsScpNameSelected] = useState(false);
  const [defaultScanningMode, setDefaultScanningMode] = useState('');

  const [shipQtyErrors, setShipQtyErrors] = useState(Array(tableData.length).fill(''));
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [rowIndexToRemove, setRowIndexToRemove] = useState(null);
  const [loading, setLoading] = useState(false); // Add loading state
  const logaction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Shipment Outward Creation:", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);



  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);


  useEffect(() => {
    const fetchOrderStatus = async () => {
      try {
        const response = await fetch(
          `${config.API_URL}/ShipmentStatus/${UM_CompanyID}`
        );

        // fetch does NOT throw on HTTP errors
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Data", data)
        // API returns { status: "Created" | "Approved", count }
        setShipmentStatus(data.status);
      } catch (error) {
        console.error('Error fetching order status:', error);
        setShipmentStatus(''); // fallback if needed
      }
    };

    if (UM_CompanyID) {
      fetchOrderStatus();
    }
  }, [UM_CompanyID]);
  const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 16,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
      transactionDetails // Array of transaction details to be inserted into audittransaction
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const handleShipQtyChange = (index, newShipQty) => {
    let numericNewShipQty = parseInt(newShipQty);
    if (newShipQty === '') {
      numericNewShipQty = 0;
    }
    if (isNaN(numericNewShipQty) || numericNewShipQty < 0 || newShipQty.includes('.')) {
      return;
    }

    const updatedTableData = [...tableData];
    const row = updatedTableData[index];
    const { shipQty, originalAvailableQty, originalPendingQty, AvailableQty } = row;

    if (numericNewShipQty > originalPendingQty) {
      showToast('error', `Ship Quantity cannot exceed the original pending quantity of ${originalPendingQty}.`, {
        duration: 3000,
      });
      return;
    }

    // Check if the newShipQty exceeds the available quantity
    if (AvailableQty + shipQty - numericNewShipQty < 0) {
      showToast('error', `Ship Quantity cannot exceed the available quantity of ${originalAvailableQty}.`, {
        duration: 3000,
      });
      return;
    }

    updatedTableData[index].shipQty = numericNewShipQty;

    const totalShippedQtyMap = {};
    updatedTableData.forEach((row) => {
      const productCode = row.productCode;
      if (!totalShippedQtyMap[productCode]) {
        totalShippedQtyMap[productCode] = 0;
      }
      const numericShipQty = parseInt(row.shipQty);
      if (!isNaN(numericShipQty)) {
        totalShippedQtyMap[productCode] += numericShipQty;
      }
    });

    updatedTableData.forEach((row) => {
      const totalShippedQty = totalShippedQtyMap[row.productCode];
      row.AvailableQty = row.originalAvailableQty - totalShippedQty;
    });
    updatedTableData[index].orderedQty = originalPendingQty - numericNewShipQty;

    setTableData(updatedTableData);

    setShipQtyErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = '';
      return newErrors;
    });

    const hasErrors = shipQtyErrors.some((err) => err !== '');
    setSubmitDisabled(hasErrors);
  };


  const parseDateFromDDMMYYYY = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('-');
    return new Date(`${year}/${month}/${day}`);
  };

  useEffect(() => {
    const storedLogisticParty = sessionStorage.getItem('selectedLogisticParty');
    const storedRouting = sessionStorage.getItem('selectedRouting');
    const storedScpName = sessionStorage.getItem('selectedScpName');
    const storedOrder = sessionStorage.getItem('selectedOrder');
    const storedVehicleNumber = sessionStorage.getItem('selectedVehicleNumber');
    const storedVehicleDimension = sessionStorage.getItem('selectedVehicleDimension');
    const storedDriverName = sessionStorage.getItem('driverName');
    const storedDriverContact = sessionStorage.getItem('driverContact');
    const storedDate = sessionStorage.getItem('selectedDate');
    const storedStatus = sessionStorage.getItem('selectedStatus');
    const storedComment = sessionStorage.getItem('comment');

    if (storedLogisticParty) setSelectedLogisticParty(storedLogisticParty);
    if (storedRouting) setSelectedRouting(storedRouting);
    if (storedScpName) setSelectedScpName(storedScpName);
    if (storedOrder) setSelectedOrder(storedOrder);
    if (storedVehicleNumber) setSelectedVehicleNumber(storedVehicleNumber);

    if (storedVehicleDimension) {
      setSelectedVehicleDimension(storedVehicleDimension);
    }

    if (storedDriverName) {
      setDriverName(storedDriverName);
    }

    if (storedDriverContact) {
      setDriverContact(storedDriverContact);
    }

    if (storedDate) {
      const parsedDate = parseDateFromDDMMYYYY(storedDate);
      setSelectedDate(parsedDate);
    }

    if (storedStatus) setSelectedStatus(storedStatus);
    if (storedComment) setComment(storedComment);
  }, []);



  useEffect(() => {
    // Enable submit if there are records in the table and shipQty is valid
    const hasTableData = tableData.length > 0;
    const isValidShipQty = tableData.every((row) => {
      const shipQtyNum = parseFloat(row.shipQty);
      const orderedQtyNum = parseFloat(row.orderedQty);
      return !isNaN(shipQtyNum) && shipQtyNum >= 0 && shipQtyNum <= orderedQtyNum;
    });

    setSubmitDisabled(!(hasTableData && isValidShipQty));
  }, [tableData]);


  // Function to toggle Vehicle Number field
  useEffect(() => {
    if (isLogisticPartySelected) {
      // Logistic Party selected, enable Vehicle Number
      setVehicleNumberDisabled(false);
    } else {
      // Logistic Party not selected, disable Vehicle Number
      setVehicleNumberDisabled(true);
    }
  }, [isLogisticPartySelected]);

  // Function to toggle SCP Name field
  useEffect(() => {
    if (isRoutingSelected) {
      // Routing selected, enable SCP Name
      setScpNameDisabled(false);
    } else {
      // Routing not selected, disable SCP Name
      setScpNameDisabled(true);
    }
  }, [isRoutingSelected]);

  // Function to toggle Order Number field
  useEffect(() => {
    if (isScpNameSelected) {
      // SCP Name selected, enable Order Number
      setOrderNumberDisabled(false);
    } else {
      // SCP Name not selected, disable Order Number
      setOrderNumberDisabled(true);
    }
  }, [isScpNameSelected]);

  const generateShipmentCode = async (scpName) => {
    try {
      const response = await fetch(`${config.API_URL}/api/shipmentcodegenerate/${scpName}`);
      if (!response.ok) {
        throw new Error('Failed to generate shipment code');
      }
      const data = await response.json();
      return data.shipmentCode;
    } catch (error) {
      console.error('Error generating shipment code:', error);
      return '';
    }
  };

  // Fetch Scanning Mode based on selectedScpId
  const fetchScanningMode = async () => {
    try {
      const response = await fetch(
        `${config.API_URL}/api/scanningmode/${selectedScpId}/${UM_CompanyID}`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch scanning mode for SCP ID: ${selectedScpId}`);
      }

      const data = await response.json();

      console.log("ScanningMode:", data.scanningmode);
      console.log("AllowedScanningMode:", data.allowedScanningMode);

      const storedStatus = sessionStorage.getItem('selectedStatus');

      if (!storedStatus) {
        setSelectedStatus(data.scanningmode);
      }

      console.log("data.allowedScanningMode", data.allowedScanningMode)
      // ✅ Disable logic
      if (data.allowedScanningMode === 2 || data.allowedScanningMode === 3) {
        setIsScanningModeDisabled(true);
      } else {
        setIsScanningModeDisabled(false);
      }

    } catch (error) {
      console.error('Error fetching scanning mode:', error);
    }
  };


  useEffect(() => {
    if (selectedScpId) {
      // Fetch SCP Name based on selectedScpId
      const fetchSCPName = async () => {
        try {
          const response = await fetch(`${config.API_URL}/api/scp/${selectedScpId}`);
          if (!response.ok) {
            throw new Error(`Failed to fetch SCP name for SCP ID: ${selectedScpId}`);
          }
          const data = await response.json();
          setSCPName(data.scpName);
        } catch (error) {
          console.error('Error fetching SCP name:', error);
        }
      };



      fetchSCPName();
      fetchScanningMode();
    }
  }, [selectedScpId]);



  useEffect(() => {
    const fetchLogisticCompanies = async () => {
      try {
        const response = await fetch(`${config.API_URL}/shipment/logisticcompany/${selectedScpId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch logistic companies');
        }
        const data = await response.json();
        setLogisticPartyOptions(data.logisticCompany);
      } catch (error) {
        console.error('Error fetching logistic companies:', error);
      }
    };

    const fetchRoutingNames = async () => {
      try {
        const response = await fetch(`${config.API_URL}/shipment/routingname/${UM_CompanyID}/${selectedScpId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch routing names');
        }
        const data = await response.json();
        setRoutingNames(data.routingname);
      } catch (error) {
        console.error('Error fetching routing names:', error);
      }
    };

    const fetchOrderNumbers = async () => {
      try {
        let scpIdForOrder = selectedScpIdForOrder !== '' ? selectedScpIdForOrder : selectedScpName;
        console.log(scpIdForOrder);
        const response = await fetch(`${config.API_URL}/orderlist/ordernumbers/${selectedScpId}/${UM_CompanyID}/${scpIdForOrder}`);
        if (!response.ok) {
          throw new Error('Failed to fetch Order numbers');
        }
        setOrderNumberDisabled(false);
        const data = await response.json();
        setOrderNumbers(data.orders);
      } catch (error) {
        console.error('Error fetching Order numbers:', error);
        setOrderNumbers([]);
      }
    };

    const fetchWithTimeout = () => {
      setTimeout(() => {
        fetchOrderNumbers();
      }, 500); // 2 seconds delay
    };
    fetchWithTimeout();
    fetchLogisticCompanies();
    fetchRoutingNames();

  }, [selectedScpIdForOrder, selectedScpName, selectedScpId, UM_CompanyID]);

  // Fetch Vehicle Numbers based on selected Logistic Party
  useEffect(() => {
    const fetchVehicleNumbers = async () => {
      try {
        if (selectedLogisticParty !== '') {
          const response = await fetch(`${config.API_URL}/logisticcompany/vehicles/${selectedLogisticParty}`);
          if (!response.ok) {
            throw new Error(`Failed to fetch vehicle numbers for Logistic Party: ${selectedLogisticParty}`);
          }
          const data = await response.json();
          setVehicleNumbers(data.vehicleData); // Update with fetched vehicleData
          setIsLogisticPartySelected(true);
        } else {
          setVehicleNumbers([]);
          setIsLogisticPartySelected(false);
        }
      } catch (error) {
        console.error('Error fetching vehicle numbers:', error);
        setVehicleNumbers([]); // Clear vehicle numbers on error
        setIsLogisticPartySelected(false);
      }
    };

    fetchVehicleNumbers();
  }, [selectedLogisticParty]);


  const handleLogisticPartyChange = async (selectedOption) => {
    const selectedPartyId = selectedOption?.value || '';
    setSelectedLogisticParty(selectedPartyId);
    sessionStorage.setItem('selectedLogisticParty', selectedPartyId);

    try {
      const response = await fetch(`${config.API_URL}/logisticcompany/vehicles/${selectedPartyId}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch vehicle numbers for Logistic Party ID: ${selectedPartyId}`);
      }
      const data = await response.json();
      setVehicleNumbers(data.vehicleData);
      setLogisticPartyEmpty(false);
      setIsLogisticPartySelected(true);
      setSelectedVehicleNumber('');
      setSelectedVehicleDimension('');
      setDriverName('');
      setDriverContact('');
      setPendingDriverName('');
      setPendingDriverContact('');
    } catch (error) {
      console.error('Error fetching vehicle numbers:', error);
      setVehicleNumbers([]);
      setIsLogisticPartySelected(false);
    }

  };




  // Fetch scp names based on selected route name
  useEffect(() => {
    const fetchRouteNames = async () => {
      try {
        if (selectedRouting !== '') {
          const response = await fetch(`${config.API_URL}/routemaster/scpname/${selectedRouting}`);
          const data = await response.json();
          setScpNames(data.scpNames); // Update with vehicleData
          setIsRoutingSelected(true);
        }
      } catch (error) {
        console.error('Error fetching vehicle numbers:', error);
        setScpNames([]); // Clear vehicle numbers on error
        setIsRoutingSelected(false);
      }
    };

    fetchRouteNames();
  }, [selectedRouting]);

  const handleRoutingChange = async (selectedOption) => {
    const selectedRoutingId = selectedOption?.value || '';
    setSelectedRouting(selectedRoutingId);

    setSelectedOrder('');
    setOrderNumbers([]);
    sessionStorage.setItem('selectedRouting', selectedRoutingId);

    try {
      const response = await fetch(`${config.API_URL}/routemaster/scpname/${selectedRoutingId}`);

      if (!response.ok) {
        throw new Error(`Failed to fetch SCP names for route ID: ${selectedRoutingId}`);
      }

      const data = await response.json();
      setScpNames(data.scpNames);
      setIsRoutingSelected(true);
      setRoutenameempty(false);
      setSelectedOrder('');
      setSelectedOrderId('');
      setSelectedScpIdForOrder('');
      setSelectedScpNameForOrder('');
      setIsScpNameSelected(false);
      setSelectedScpName('');
      sessionStorage.removeItem('selectedScpName');
    } catch (error) {
      console.error('Error fetching SCP names:', error);
      setScpNames([]);
      setIsRoutingSelected(false);
    }

  };


  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  const handleAddAllButtonClick = async () => {
    logaction("handleAddAllButtonClick: clicked");

    let isValid = true;

    // Validate Route
    if (!selectedRouting) {
      logaction("Route not selected", true);
      setRoutenameempty(true);
      isValid = false;
    } else {
      setRoutenameempty(false);
    }

    // Validate SCP
    if (!selectedScpIdForOrder && !selectedScpName) {
      logaction("SCP not selected", true);
      setScpnameempty(true);
      isValid = false;
    } else {
      setScpnameempty(false);
    }

    if (!isValid) {
      logaction("Validation failed", true);
      return;
    }

    if (orderNumbers.length === 0) {
      logaction("No order numbers available for selected SCP", true);
      showToast('error', "There are no order numbers available for selected SCP.");
      return;
    }

    // Fetch SCP Name
    let scpName = "";
    try {
      logaction("Fetching SCP name");
      const res = await fetch(`${config.API_URL}/api/scpname/${selectedScpName}`);
      const data = await res.json();
      scpName = data.success ? data.scpName : "";
      logaction("SCP name fetch completed");
    } catch (e) {
      logaction("Error fetching SCP name", true);
    }

    try {
      let lastSerialNumber =
        tableData.length > 0 ? tableData[tableData.length - 1].srNo : 0;

      const runningAvailableMap = {};

      // preload from existing table
      tableData.forEach(row => {
        const code = row.productCode;

        if (!runningAvailableMap[code]) {
          runningAvailableMap[code] = row.originalAvailableQty;
        }

        runningAvailableMap[code] -= (parseInt(row.shipQty) || 0);
      });

      logaction("Fetching order details for all orders");

      const allOrderDetails = await Promise.all(
        orderNumbers.map(async (order) => {

          const response = await fetch(
            `${config.API_URL}/orderdetails/${order.orderNumber}/${selectedScpId}`
          );

          const data = await response.json();

          return data.orderDetails
            .filter(d => d.ORDIT_PendingQty !== 0)
            .map(orderDetail => {

              const orderNumberStr = `${order.orderNumber}`;

              const exists = tableData.some(
                row =>
                  row.orderNumber === orderNumberStr &&
                  row.productCode === orderDetail.PL_ProductCode
              );

              if (exists) return null;

              const code = orderDetail.PL_ProductCode;

              const originalAvailable = Math.max(
                0,
                parseInt(orderDetail.totalPackSize) || 0
              );

              if (runningAvailableMap[code] === undefined) {
                runningAvailableMap[code] = originalAvailable;
              }

              const remainingAvailable = runningAvailableMap[code];

              const autoShipQty = Math.min(
                orderDetail.ORDIT_PendingQty,
                remainingAvailable
              );

              runningAvailableMap[code] -= autoShipQty;

              lastSerialNumber++;

              return {
                srNo: lastSerialNumber,
                scpId: selectedScpIdForOrder || selectedScpName,
                scpName: selectedScpNameForOrder || scpName,

                orderNumber: orderNumberStr,
                productName: orderDetail.PL_ProductName,
                productCode: code,

                originalAvailableQty: originalAvailable,
                AvailableQty: runningAvailableMap[code],

                SHPD_OrderQty: orderDetail.ORDIT_OrderQTY,

                originalPendingQty: orderDetail.ORDIT_PendingQty,
                orderedQty: orderDetail.ORDIT_PendingQty - autoShipQty,

                shipQty: autoShipQty,
                volume: orderDetail.Volume,
              };

            })
            .filter(Boolean);
        })
      );

      // const flattened = allOrderDetails.flat();

      // if (flattened.length === 0) {
      //   logaction("All orders already added for this SCP", true);
      //   showToast('error', "All Orders are already added for this SCP.");
      //   return;
      // }

      // setTableData(prev => [...prev, ...flattened]);
      // logaction(`Added ${flattened.length} rows to table`);
      const flattened = allOrderDetails.flat();

      if (flattened.length === 0) {
        logaction("All orders already added for this SCP", true);
        showToast('error', "All Orders are already added for this SCP.");
        return;
      }

      // ✅ Update existing rows' AvailableQty
      const updatedExistingRows = tableData.map(row => {
        const code = row.productCode;

        if (runningAvailableMap[code] !== undefined) {
          return {
            ...row,
            AvailableQty: runningAvailableMap[code]
          };
        }

        return row;
      });

      // ✅ Combine updated old + new
      const finalData = [...updatedExistingRows, ...flattened];

      setTableData(finalData);

      logaction(`Added ${flattened.length} rows to table`);


    } catch (err) {
      console.error("Error adding all:", err);
      logaction(`Error adding all: ${err?.message || err}`, true);
    }
  };



  const handleAddButtonClick = async () => {
    logaction("handleAddButtonClick: clicked");

    let isValid = true;

    // Validate Route
    if (!selectedRouting) {
      console.error("Route Name not selected");
      logaction("Route Name not selected", true);
      setRoutenameempty(true);
      isValid = false;
    } else {
      setRoutenameempty(false);
    }

    // Validate SCP
    if (!selectedScpIdForOrder && !selectedScpName) {
      console.error("SCP Name not selected");
      logaction("SCP Name not selected", true);
      setScpnameempty(true);
      isValid = false;
    } else {
      setScpnameempty(false);
    }

    // Validate Order
    if (!selectedOrder) {
      console.error("Order Number not selected");
      logaction("Order Number not selected", true);
      setOrdernoempty(true);
      isValid = false;
    } else {
      setOrdernoempty(false);
    }

    if (!isValid) {
      logaction("Validation failed", true);
      return;
    }

    try {
      logaction(`Fetching order details for order ${selectedOrder}`);

      const response = await fetch(
        `${config.API_URL}/orderdetails/${selectedOrder}/${selectedScpId}`
      );

      if (!response.ok) {
        logaction("Failed to fetch order details", true);
        throw new Error("Failed to fetch order details");
      }

      const responseData = await response.json();

      const filteredOrderDetails = responseData.orderDetails.filter(
        (orderDetail) => orderDetail.ORDIT_PendingQty !== 0
      );

      // Ensure SCP names are loaded
      if (scpNames.length === 0) {
        console.error("SCP Names not loaded yet");
        logaction("SCP Names not loaded yet", true);
        return;
      }

      let allExistInTable = true;

      const newTableRows = await Promise.all(
        filteredOrderDetails.map(async (orderDetail, index) => {
          const orderProductExists = tableData.some(
            (row) =>
              row.orderNumber === selectedOrder &&
              row.productCode === orderDetail.PL_ProductCode
          );

          if (orderProductExists) {
            return null;
          }

          allExistInTable = false;

          let scpName = "";

          try {
            const scpId = selectedScpName;

            logaction(`Fetching SCP name for ${scpId}`);

            const scpNameResponse = await fetch(
              `${config.API_URL}/api/scpname/${scpId}`
            );

            if (!scpNameResponse.ok) {
              console.error("SCP Name not found for SCP ID:", scpId);
              logaction(`SCP Name not found for SCP ID: ${scpId}`, true);
            } else {
              const scpNameData = await scpNameResponse.json();
              scpName = scpNameData.success ? scpNameData.scpName : "";
            }
          } catch (error) {
            console.error("Error fetching SCP Name:", error);
            logaction(`Error fetching SCP Name: ${error?.message || error}`, true);
          }

          const alreadyShippedForProduct = tableData
            .filter(r => r.productCode === orderDetail.PL_ProductCode)
            .reduce((sum, r) => sum + (parseInt(r.shipQty) || 0), 0);

          const remainingAvailable =
            Math.max(
              0,
              (isNaN(orderDetail.totalPackSize) ? 0 : orderDetail.totalPackSize)
              - alreadyShippedForProduct
            );

          const autoShipQty = Math.min(
            orderDetail.ORDIT_PendingQty,
            remainingAvailable
          );

          return {
            srNo: tableData.length + index + 1,

            scpId: selectedScpIdForOrder || selectedScpName,
            scpName: selectedScpNameForOrder || scpName,

            orderNumber: selectedOrder,
            productName: orderDetail.PL_ProductName,
            productCode: orderDetail.PL_ProductCode,

            originalAvailableQty: Math.max(
              0,
              isNaN(orderDetail.totalPackSize)
                ? 0
                : orderDetail.totalPackSize
            ),

            AvailableQty: remainingAvailable - autoShipQty,

            SHPD_OrderQty: orderDetail.ORDIT_OrderQTY,

            orderedQty: orderDetail.ORDIT_PendingQty - autoShipQty,
            originalPendingQty: orderDetail.ORDIT_PendingQty,

            shipQty: autoShipQty,

            volume: orderDetail.Volume,
          };
        })
      );

      const validNewRows = newTableRows.filter((row) => row !== null);

      if (validNewRows.length === 0 && allExistInTable) {
        logaction("All selected Orders and Products already added", true);
        showToast('error', "All selected Orders and Products are already added.");
        setSelectedOrder("");
        setSelectedOrderId("");
        return;
      }

      console.log("New rows to add:", validNewRows);
      logaction(`Adding ${validNewRows.length} new rows`);

      // 🔥 Build running map again
      const runningAvailableMap = {};

      // preload existing
      tableData.forEach(row => {
        const code = row.productCode;

        if (!runningAvailableMap[code]) {
          runningAvailableMap[code] = row.originalAvailableQty;
        }

        runningAvailableMap[code] -= (parseInt(row.shipQty) || 0);
      });

      // subtract new shipments too
      validNewRows.forEach(row => {
        const code = row.productCode;
        runningAvailableMap[code] -= (parseInt(row.shipQty) || 0);
      });

      // ✅ update existing rows
      const updatedExistingRows = tableData.map(row => {
        const code = row.productCode;

        if (runningAvailableMap[code] !== undefined) {
          return {
            ...row,
            AvailableQty: runningAvailableMap[code]
          };
        }

        return row;
      });

      setTableData([...updatedExistingRows, ...validNewRows]);

      setRoutenameempty(false);
      setScpnameempty(false);
      setOrdernoempty(false);
      setSelectedOrder("");
      setSelectedOrderId("");

      logaction("handleAddButtonClick completed successfully");

    } catch (error) {
      console.error("Error adding table data:", error);
      logaction(`Error adding table data: ${error?.message || error}`, true);
    }
  };



  const showConfirmDialog = (index) => {
    logaction(`showConfirmDialog: index ${index}`);
    setRowIndexToRemove(index);
    setShowConfirmation(true);
  };

  const hideConfirmDialog = () => {
    logaction("hideConfirmDialog");
    setRowIndexToRemove(null);
    setShowConfirmation(false);
  };

  const handleConfirmedRemoval = () => {
    logaction(`handleConfirmedRemoval: index ${rowIndexToRemove}`);
    handleRemoveButtonClick(rowIndexToRemove);
    hideConfirmDialog();
  };

  const handleRemoveButtonClick = (index) => {
    logaction(`handleRemoveButtonClick: index ${index}`);

    const updatedTableData = [...tableData];
    const removedRow = updatedTableData[index];
    const productCode = removedRow.productCode;
    const shipQty = removedRow.shipQty;

    logaction(
      `Removing row with productCode ${productCode} and shipQty ${shipQty}`
    );

    updatedTableData.forEach((row) => {
      if (row.productCode === productCode) {
        row.AvailableQty += shipQty;
      }
    });

    updatedTableData.splice(index, 1);

    const updatedShipQtyErrors = [...shipQtyErrors];

    const reindexedTableData = updatedTableData.map((row, idx) => ({
      ...row,
      srNo: idx + 1,
    }));

    setTableData(reindexedTableData);
    setShipQtyErrors(updatedShipQtyErrors);

    logaction("handleRemoveButtonClick completed");
  };

  const validateBeforeConfirm = async (data) => {

    let isValid = true;

    if (!data.logisticParty && !selectedLogisticParty) {
      setLogisticPartyEmpty(true);
      isValid = false;
    } else setLogisticPartyEmpty(false);

    if (!selectedStatus) {
      setScanningModeEmpty(true);
      isValid = false;
    } else setScanningModeEmpty(false);

    // ShipQty validations
    for (const item of tableData) {
      if (item.shipQty === '') {
        showToast('error',
          `Please Enter Ship Quantity for Product : ${item.productName}.`
        );
        isValid = false;
      }
      else if (parseInt(item.shipQty) <= 0) {
        showToast('error',
          `Please Enter Ship Quantity for Product : ${item.productName}.`
        );
        isValid = false;
      }
    }

    if (!isValid) return;

    if (tableData.length === 0) {
      showToast('error',
        "At least one order is required to create the shipment."
      );
      return
    }

    // Driver validation
    if (selectedVehicleNumber) {
      if (!driverName?.trim() || !driverContact?.trim()) {
        showToast('error', "Please enter the Driver Details.");
        setShowDriverModal(true);
        return;
      }
    }

    // Capacity validation
    if (canCalculateCapacity && usedVolume > vehicleCapacity) {
      showToast('error',
        `Vehicle capacity exceeded with ${rawUsedPercentage.toFixed(2)}%`
      );
      return;
    }



    const code = await generateShipmentCode(scpName);

    setPendingShipmentCode(code);

    // ✅ Only here show confirmation
    setshowconfimationModal(true);
  };



  const onSubmit = async (data) => {

    logaction("onSubmit clicked");
    setshowconfimationModal(false)

    if (isSubmitting) {
      logaction("Already submitting — blocked duplicate submit", true);
      return;
    }

    setIsSubmitting(true);
    console.log("dataaaa", data);

    let isValid = true;

    if (!data.logisticParty && !selectedLogisticParty) {
      logaction("Logistic party empty", true);
      setLogisticPartyEmpty(true);
      isValid = false;
    } else {
      setLogisticPartyEmpty(false);
    }

    // if (!data.selectedVehicleNumber && selectedVehicleNumber) {
    //   logaction("vehicle empty", true);
    //   setVehicleNumberEmpty(true);
    //   isValid = false;
    // } else {
    //   setVehicleNumberEmpty(false);
    // }

    if (!selectedStatus) {
      logaction("Scanning mode empty", true);
      setScanningModeEmpty(true);
      isValid = false;
    } else {
      setScanningModeEmpty(false);
    }

    for (const item of tableData) {
      if (item.shipQty === '') {
        logaction(`ShipQty empty for ${item.productCode}`, true);
        showToast('error', `Please Enter Ship Quantity for Product : ${item.productName}.`);
        isValid = false;
      } else if (parseInt(item.shipQty) <= 0) {
        logaction(`Invalid shipQty for ${item.productCode}`, true);
        showToast('error', `Please Enter Ship Quantity for Product : ${item.productName}.`);
        isValid = false;
      }
    }

    if (tableData.length === 0) {
      logaction("No orders added to shipment", true);
      showToast('error', "At least one order is required to create the shipment.");
      isValid = false;
    }

    if (!isValid) {
      logaction("Validation failed", true);
      setIsSubmitting(false);
      return;
    }

    if (selectedVehicleNumber) {
      if (!driverName?.trim() || !driverContact?.trim()) {
        logaction("Driver details missing", true);
        showToast('error', "Please enter the Driver Details.");
        setShowDriverModal(true);
        setIsSubmitting(false);
        return;
      }
    }

    if (canCalculateCapacity && usedVolume > vehicleCapacity) {
      logaction("Vehicle capacity exceeded", true);
      showToast('error',
        `Vehicle capacity exceeded with ${rawUsedPercentage.toFixed(2)}% of its capacity. Please reduce shipment quantity or select a larger vehicle.`
      );

      setIsSubmitting(false);
      return;
    }

    const shipQtyMap = {};

    for (const item of tableData) {
      const { productCode, productName, shipQty, AvailableQty } = item;

      if (!shipQtyMap[productCode]) {
        shipQtyMap[productCode] = {
          sumShipQty: 0,
          availableQty: AvailableQty,
          productName: productName,
        };
      }

      shipQtyMap[productCode].sumShipQty += parseInt(shipQty, 10);
    }

    const formattedDateForBackend = new Date(selectedDate)
      .toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })
      .replace(/\//g, '/');

    logaction("Generating shipment code");
    const generatedShipmentCode = await generateShipmentCode(scpName);
    setShipmentCode(generatedShipmentCode);

    data.UM_CompanyID = parseInt(UM_CompanyID);
    data.UM_CompanyGrpID = parseInt(UM_CompanyGrpID);
    data.UM_UserId = parseInt(UM_UserId);
    data.selectedScpId = parseInt(selectedScpId);
    data.tableData = tableData;
    data.selectedOrderId = selectedOrderId;
    data.shipmentCode = generatedShipmentCode;
    data.selectedLogisticParty = selectedLogisticParty;
    data.selectedVehicleNumber = selectedVehicleNumber;
    data.selectedRouting = selectedRouting;
    data.selectedDate = formattedDateForBackend;
    data.selectedStatus = selectedStatus || defaultScanningMode;
    data.comment = comment;
    data.shipmentStatus = shipmentStatus;
    data.shipmentType = shipmentType;
    data.driverName = driverName;
    data.driverContact = driverContact;

    console.log("TABLE DATA (before productId)", data.tableData);

    const fetchProductId = async (productName) => {
      try {
        logaction(`Fetching productId for ${productName}`);
        const response = await fetch(`${config.API_URL}/api/product`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ productName }),
        });

        if (!response.ok) {
          logaction("Failed to fetch product ID", true);
          throw new Error('Failed to fetch product ID');
        }

        const responseData = await response.json();
        return responseData.productId;
      } catch (error) {
        console.error('Error fetching product ID:', error);
        logaction("Error fetching product ID", true);
        return null;
      }
    };

    try {

      logaction("Attaching productIds and updating pending qty");

      for (const item of data.tableData) {
        const shipQtyNum = parseInt(item.shipQty);
        const orderedQtyNum = parseInt(item.SHPD_OrderQty);
        const orderNumber = item.orderNumber;

        if (isNaN(shipQtyNum) || isNaN(orderedQtyNum)) {
          logaction("Invalid shipQty or orderedQty", true);
          console.error('Invalid shipQty or orderedQty:', item.shipQty, item.orderedQty);
          showToast('error', `shipment quantity or ordered quantity is invalid.`);
          continue;
        }

        const pendingQty = parseInt(item.orderedQty);

        const productId = await fetchProductId(item.productName);

        if (productId === null) {
          logaction(`ProductId not found for ${item.productName}`, true);
          console.error('Product ID not found for:', item.productName);
          setIsSubmitting(false);
          return;
        }

        item.productId = productId;

        const shipQtyResponse = await fetch(`${config.API_URL}/api/ordermaster/updatePendingQty`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            pendingQty,
            orderedQty: orderedQtyNum,
            productId,
            orderNumber
          }),
        });

        if (!shipQtyResponse.ok) {
          logaction("Failed updating pending qty", true);
          throw new Error(`Failed to update Ship Qty for product ID ${productId}`);
        }
      }

      logaction("Updating block qty");

      for (const productCode in shipQtyMap) {
        const { sumShipQty } = shipQtyMap[productCode];

        console.log(`Updating Block Qty for Product Code: ${productCode}`);

        const updateBlockQtyResponse = await fetch(`${config.API_URL}/inventory/updateBlockQty`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            blockQty: sumShipQty,
            scpid: selectedScpId,
            productCode
          }),
        });

        if (!updateBlockQtyResponse.ok) {
          logaction(`Block qty failed for ${productCode}`, true);
          throw new Error(`Failed to update Block Qty for Product Code ${productCode}`);
        }

        console.log(`Block Qty updated successfully for Product Code: ${productCode}`);
      }

      logaction("Creating shipment");

      const response = await fetch(`${config.API_URL}/api/shipment/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        logaction("Shipment creation failed", true);
        throw new Error('Failed to create shipment');
      }

      toast.success(`Shipment : ${generatedShipmentCode} created successfully.`, {
        onClose: () => {
          handleReset();
          setIsSubmitting(false);
          setLoading(false);
        },
      });

      logaction(`Shipment ${generatedShipmentCode} created successfully`);

      const transactionDetails = [
        {
          AUTRN_ParamererName: "Shipment Code",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: generatedShipmentCode
        },
        {
          AUTRN_ParamererName: "Shipment Type",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: shipmentType
        },
        {
          AUTRN_ParamererName: "Shipment Date",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: formattedDateForBackend
        },
        {
          AUTRN_ParamererName: "Scanning Mode",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: selectedStatus || defaultScanningMode
        },
        {
          AUTRN_ParamererName: "Logistic Party Name",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: selectedLogisticParty
            ? logisticPartySelectOptions.find(opt => opt.value === selectedLogisticParty)?.label || "-"
            : "-"
        },
        {
          AUTRN_ParamererName: "Vehicle Number",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: selectedVehicleNumber
            ? vehicleNumbers.find(v => String(v.LGCVM_ID) === selectedVehicleNumber)?.LGCVM_VehicleNumber || "-"
            : "-"
        },
        {
          AUTRN_ParamererName: "Route for Shipment Location",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: selectedRouting
            ? routingNames.find(route => String(route.RUTL_ID) === selectedRouting)?.RUTL_Name || "-"
            : "-"
        },
        {
          AUTRN_ParamererName: "Comment",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: comment || "-"
        },
        {
          AUTRN_ParamererName: "Shipment Status",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: shipmentStatus
        },
        {
          AUTRN_ParamererName: "Shipment Details",
          AUTRN_OldValue: "-",
          AUTRN_NewValue: JSON.stringify(tableData.map(row => ({
            "SCP Name": row.scpName,
            "Order Number": row.orderNumber,
            "Product Name": row.productName,
            "Product Code": row.productCode,
            "Available Quantity": row.AvailableQty,
            "Ordered Quantity": row.SHPD_OrderQty,
            "Pending Quantity": row.orderedQty,
            "Ship Quantity": row.shipQty
          })))
        }
      ];

      logaction("Writing audit log");

      await logAudit(
        "Shipment Outward Creation",
        `Shipment: ${generatedShipmentCode} is created successfully`,
        "-",
        generatedShipmentCode,
        transactionDetails
      );

      logaction("Saving notification");

      try {
        const notificationResponse = await fetch(`${config.API_URL}/notificationmaster/save`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            NFM_EventType: 'Shipment Creation',
            NFM_EventBy: UM_UserId,
            NFM_Status: 0,
            NFM_EventMessage: `Shipment with Shipment code: '${generatedShipmentCode}' is created successfully`,
            NFM_CompanyID: UM_CompanyID,
            NFM_CompanyGrpID: UM_CompanyGrpID,
            NFM_SCPID: selectedScpId
          }),
        });

        if (!notificationResponse.ok) {
          logaction("Notification save failed", true);
          throw new Error('Failed to save notification');
        }

      } catch (notificationError) {
        console.error('Error saving notification:', notificationError);
        logaction("Notification error", true);
      }

      logaction("onSubmit completed successfully");

    } catch (error) {
      console.error('Error creating shipment:', error);
      logaction(`Error creating shipment: ${error?.message}`, true);
      setIsSubmitting(false);
    }
  };



  const handleReset = () => {

    // 1️⃣ Reset react-hook-form
    reset();

    // 2️⃣ Clear table & order states
    setTableData([]);
    setSelectedOrder('');
    setSelectedOrderId('');
    setSelectedScpIdForOrder('');
    setSelectedScpNameForOrder('');
    setIsScpNameSelected(false);

    // 3️⃣ Clear vehicle + driver states
    setSelectedVehicleNumber('');
    setSelectedVehicleDimension('');
    setDriverName('');
    setDriverContact('');
    setPendingDriverName('');
    setPendingDriverContact('');
    setShowDriverModal(false);

    // 4️⃣ Clear dropdown selections
    setSelectedLogisticParty('');
    setSelectedRouting('');
    setSelectedScpName('');
    setSelectedStatus('');
    fetchScanningMode();

    // 5️⃣ Reset form values
    setComment('');
    setSelectedDate(new Date());

    // 6️⃣ Reset errors & flags
    setDriverErrors({ name: false, contact: false });
    setShipQtyErrors([]);
    setLogisticPartyEmpty(false);
    setVehicleNumberEmpty(false);
    setScanningModeEmpty(false);
    setRoutenameempty(false);
    setScpnameempty(false);
    setOrdernoempty(false);

    // 7️⃣ Reset enable/disable UI logic
    setIsLogisticPartySelected(false);
    setIsRoutingSelected(false);
    setVehicleNumberDisabled(true);
    setScpNameDisabled(true);
    setOrderNumberDisabled(true);
    setSubmitDisabled(true);
    [
      'selectedLogisticParty',
      'selectedRouting',
      'selectedScpName',
      'selectedOrder',
      'selectedVehicleNumber',
      'selectedVehicleDimension',
      'driverName',
      'driverContact',
      'tableData',
      'selectedDate',
      'selectedStatus',
      'comment'
    ].forEach(key => sessionStorage.removeItem(key));
  };




  const handleScpNameChange = async (selectedOption) => {

    const selectedValue = selectedOption?.value || '';

    setSelectedScpIdForOrder(selectedValue);
    setScpnameempty(false);
    setSelectedScpNameForOrder(selectedOption?.label || '');
    sessionStorage.setItem('selectedScpName', selectedValue);
    setIsScpNameSelected(!!selectedValue);
    setSelectedOrder('');
    setSelectedOrderId('');

    if (!selectedValue) {
      setOrderNumbers([]);
      return;
    }

    try {
      const scpIdForOrder = selectedValue;
      const response = await fetch(`${config.API_URL}/orderlist/ordernumbers/${selectedScpId}/${UM_CompanyID}/${scpIdForOrder}`);

      if (!response.ok) {
        throw new Error('Failed to fetch Order numbers');
      }

      const data = await response.json();
      setOrderNumbers(data.orders);
    } catch (error) {
      console.error('Error fetching Order numbers:', error);
      setOrderNumbers([]);
    }
  };


  // Function to handle selecting an order from the dropdown
  const handleOrderSelect = async (selectedOption) => {

    const selectedOrderNumber = selectedOption?.value || '';
    setOrdernoempty(false);
    setSelectedOrder(selectedOrderNumber);
    sessionStorage.setItem('selectedOrder', selectedOrderNumber);
  };

  const handleCloseModal = () => {
    setPendingDriverName(driverName);
    setPendingDriverContact(driverContact);

    setDriverErrors({
      name: false,
      contact: false,
    });

    setShowDriverModal(false);
  };


  // Save tableData to local storage when it changes
  useEffect(() => {
    sessionStorage.setItem('tableData', JSON.stringify(tableData));
  }, [tableData]);



  const handleVehicleNumberChange = (selectedOption) => {
    const selectedId = selectedOption?.value || '';
    const selectedDimension = selectedOption?.dimension || '';

    // ✅ NEW: get driver details from vehicle
    const driverNameFromVehicle = selectedOption?.LGCVM_DriverName || "";
    const driverContactFromVehicle = selectedOption?.LGCVM_DriverNumber || "";

    // ✅ APPLY VEHICLE
    setSelectedVehicleNumber(selectedId);
    setSelectedVehicleDimension(selectedDimension);

    setPendingDriverName(driverNameFromVehicle);
    setPendingDriverContact(driverContactFromVehicle);

    // ✅ SET DRIVER DETAILS
    setDriverName(driverNameFromVehicle);
    setDriverContact(driverContactFromVehicle);

    // ✅ SESSION STORAGE
    sessionStorage.setItem('selectedVehicleNumber', selectedId);
    sessionStorage.setItem('selectedVehicleDimension', selectedDimension);
    sessionStorage.setItem('driverName', driverNameFromVehicle);
    sessionStorage.setItem('driverContact', driverContactFromVehicle);
    setShowDriverModal(true);

  };

  const handleDateChange = (date) => {
    console.log("handleDateChange(): Started");
    setModalSelectedDate(date);
    setShowModal(true);
    console.log(`handleDateChange(): Date changed to ${date ? format(date, 'dd-MM-yyyy') : 'null'}`);
    console.log("handleDateChange(): Ended");
  };

  const handleModalCancel = () => {
    setShowModal(false);
    console.log("handleModalCancel(): Date Modal Closed");
  };

  const handleModalConfirm = () => {
    setSelectedDate(modalSelectedDate);
    console.log("handleModalConfirm() : Confirm Modal for date change is opened");
    sessionStorage.setItem('selectedDate', modalSelectedDate ? format(modalSelectedDate, 'dd-MM-yyyy') : '');
    setShowModal(false);
  };

  const handleStatuschange = (e) => {
    const selectedStatus = e.target.value;
    console.log("Scanning mode", selectedStatus);
    console.log(`handleStatuschange(): Status changed to ${selectedStatus}`)
    setSelectedStatus(selectedStatus);
    sessionStorage.setItem('selectedStatus', selectedStatus);
  };

  const handleCommentChange = (event) => {
    const newComment = event.target.value;
    setComment(newComment);
    sessionStorage.setItem('comment', newComment);
  };

  const isRoutingLocationDisabled = () => {
    return tableData.length > 0;
  };

  const hasVehicleCapacity = Number(selectedVehicleDimension) > 0;

  const hasProductVolume = tableData.some(row =>
    Number(row.shipQty) > 0 && Number(row.volume) > 0
  );

  const canCalculateCapacity = hasVehicleCapacity && hasProductVolume;


  const usedVolume = canCalculateCapacity
    ? tableData.reduce((sum, row) => {
      const qty = Number(row.shipQty) || 0;
      const volume = Number(row.volume) || 0;
      return sum + qty * volume;
    }, 0)
    : 0;

  const vehicleCapacity = canCalculateCapacity
    ? Number(selectedVehicleDimension) || 0
    : 0;

  const rawUsedPercentage = canCalculateCapacity && vehicleCapacity
    ? Math.round(((usedVolume / vehicleCapacity) * 100 + Number.EPSILON) * 100) / 100
    : 0;

  const barPercentage = Math.min(rawUsedPercentage, 100);

  const remainingVolume = canCalculateCapacity
    ? Math.max(vehicleCapacity - usedVolume, 0)
    : 0;



  return (
    <>
      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />
      {loading && (
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          zIndex: 1000
        }} />
      )}
      {isSubmitting && (
        <div style={{
          position: 'fixed', // Sit on top of the page content
          left: 0,
          top: 0,
          width: '100%', // Full width
          height: '100%', // Full height
          zIndex: 1000 // Sit on top of the other elements
        }} />
      )}


      <form onSubmit={handleSubmit(onSubmit)}>
        {canCalculateCapacity && (
          <div className="vehicle-capacity-fixed">
            <div className="vehicle-capacity-inline">

              <div className="capacity-summary-compact">
                <strong>{rawUsedPercentage.toFixed(2)}%</strong> Used

                <span className="ms-2 capacity-info-icon" tabIndex={0}>
                  <AiOutlineInfoCircle />

                  <div className="capacity-tooltip">
                    <div><strong>Vehicle Capacity : </strong> {vehicleCapacity}</div>
                    <div><strong>Used : </strong> {usedVolume.toFixed(2)}</div>
                    <div><strong>Remaining : </strong> {remainingVolume.toFixed(2)}</div>
                  </div>
                </span>
              </div>

              <div className="capacity-bar-inline">
                <div className="capacity-bar-bg">
                  <div
                    className={`capacity-bar-fill ${rawUsedPercentage > 100
                      ? 'over'
                      : rawUsedPercentage > 80
                        ? 'warning'
                        : 'normal'
                      }`}
                    style={{ width: `${barPercentage}%` }}
                  />
                </div>
              </div>

              {rawUsedPercentage > 100 && (
                <div className="overload-alert-inline">
                  ⚠ Capacity Exceeded
                </div>
              )}

            </div>
          </div>
        )}


        <div className='main_container' style={{ paddingTop: canCalculateCapacity ? '30px' : '12px' }}>

          <div className="row ">
            <div className="col-md-12">
              <div className="page-header">
                <h2 className="formHeading">Shipment Master</h2>



              </div>
              <div className="row ">
                {/* <div className='column'> */}
                <div className="col-md-4">
                  <label className="form-label">Shipment Type</label>
                  <input
                    type="text"
                    value={shipmentType}
                    disabled
                    style={{
                      backgroundColor: '#f2f2f2',
                      color: '#6c757d',
                    }}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Shipment Date </label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    dateFormat="dd/MM/yyyy"
                    onKeyDown={(e) => e.preventDefault()}
                    disabled
                    style={{
                      backgroundColor: '#f2f2f2',
                      color: '#6c757d',
                    }}
                  />
                  {showModal && (
                    <div className="popup_overlay">
                      <div className="resetpopup">
                        <h1>:: User Confirmation ::</h1>
                        <h4>Are you sure you want to change the date ?</h4>
                        <div className="popup_btn_container">
                          <button className="yes_btn " onClick={handleModalConfirm}>
                            YES
                          </button>
                          <button className="no_btn " onClick={handleModalCancel}>
                            NO
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label">Shipment Status</label>
                  <input
                    type="text"

                    value="Created"
                    disabled
                    style={{
                      backgroundColor: '#f2f2f2',
                      color: '#6c757d',
                    }}
                  />
                </div>

                <div className="col-md-4 row mt-2">
                  <div className="col-md-11">
                    <label className="form-label">
                      Logistic Party Name {logisticPartyEmpty && <span className="text-danger"> *</span>}
                    </label>
                    <div className='select-container'>
                      <Select
                        className="routing_select-box"
                        classNamePrefix="react-select"
                        components={{ SingleValue: CustomSingleValue }}
                        options={logisticPartySelectOptions}
                        value={logisticPartySelectOptions.find(opt => opt.value === selectedLogisticParty) || null}
                        onChange={handleLogisticPartyChange}
                        placeholder="--Select--"
                        onMenuOpen={() => handleSelectOpen('LGName')}
                        onMenuClose={handleSelectClose}
                        maxMenuHeight={"120px"}
                      />
                      <div className='icon-container_list myList'>
                        <i>
                          {isSelectOpen === 'LGName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                        </i>
                      </div>
                    </div>

                  </div>
                  <div className="col-md-1">
                    <Link to={`/dashboard/lgcm`}>
                      <img src={add} alt="Add All Icon"
                        title='Create Vehicle'
                        style={{
                          width: '19px',
                          height: '19px',
                          marginTop: '41px',
                          filter: 'brightness(0.4)'
                          // marginLeft: '-10px'
                        }} />
                    </Link>
                  </div>
                </div>

                <div className="col-md-4 row mt-2" style={{ marginLeft: '13px' }}>
                  <div className="col-md-11">
                    <label className="form-label">
                      Vehicle Number {vehicleNumberEmpty && <span className="text-danger"> *</span>}
                    </label>

                    <div className='select-container'>
                      <Select
                         className="routing_select-box"
                         classNamePrefix="react-select"
                         components={{ SingleValue: CustomSingleValue }}
                        options={vehicleNumbers.map(vehicle => ({
                          value: String(vehicle.LGCVM_ID),
                          label: vehicle.LGCVM_VehicleNumber,
                          dimension: vehicle.LGCVM_Dimension,
                          LGCVM_DriverName: vehicle.LGCVM_DriverName,
                          LGCVM_DriverNumber: vehicle.LGCVM_DriverNumber
                        }))}
                        value={
                          vehicleNumbers.find(v => String(v.LGCVM_ID) === selectedVehicleNumber)
                            ? {
                              value: String(selectedVehicleNumber),
                              label: vehicleNumbers.find(v => String(v.LGCVM_ID) === selectedVehicleNumber)?.LGCVM_VehicleNumber,
                              dimension: selectedVehicleDimension,
                            }
                            : null
                        }
                        onChange={handleVehicleNumberChange}
                        placeholder="--Select--"
                        isDisabled={vehicleNumberDisabled}
                        onMenuOpen={() => handleSelectOpen('Vehicle')}
                        onMenuClose={handleSelectClose}
                        maxMenuHeight={"120px"}
                      />


                      <div className='icon-container_list myList'>
                        <i>
                          {isSelectOpen === 'Vehicle' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                        </i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1 d-flex align-items-end justify-content-center">
                    <div
                      className={`driver-icon-btn ${!selectedVehicleNumber ? 'disabled' : ''}`}
                      onClick={() => {
                        if (!selectedVehicleNumber) return;
                        setShowDriverModal(true);
                      }}
                      title="Add Driver Details"
                    >
                      <BsPersonBadge size={26} />
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mt-2" style={{ marginLeft: '21px' }}>
                  <label className="form-label">
                    Scanning Mode {scanningModeEmpty && <span className="text-danger"> *</span>}
                  </label>

                  {isScanningModeDisabled ? (
                    <input
                      type="text"
                      value={
                        scanningModeOptions.find(opt => opt.id === selectedStatus)?.label || ""
                      }
                      disabled
                      style={{
                        backgroundColor: "#f2f2f2",
                        color: "#6c757d",
                        width: "100%",           // ← added for better consistency
                        padding: "6px 12px",     // ← typical select padding
                        border: "1px solid #ced4da",
                        borderRadius: "4px"
                      }}
                    />
                  ) : (
                    <div className="select-container">
                      <Select
                         className="routing_select-box"
                         classNamePrefix="react-select"
                         components={{ SingleValue: CustomSingleValue }}
                        options={scanningModeOptions}
                        value={
                          scanningModeOptions.find(opt => opt.id === selectedStatus) || null
                        }
                        onChange={(option) => {
                          const selectedValue = option ? option.id : '';
                          handleStatuschange({ target: { value: selectedValue } });
                        }}
                        placeholder="--Select--"
                        onMenuOpen={() => handleSelectOpen('scanningMode')}
                        onMenuClose={handleSelectClose}
                        maxMenuHeight={140}
                        isSearchable={false}
                      />

                      <div className="icon-container_list myList">
                        <i>
                          {isSelectOpen === 'scanningMode' ? (
                            <IoCaretUpOutline />
                          ) : (
                            <IoCaretDownOutline />
                          )}
                        </i>
                      </div>
                    </div>
                  )}
                </div>



                <div className="col-md-4 row mt-2">
                  <div className="col-md-11">
                    <label className="form-label">
                      Route for Shipment Location {routenameempty && <span className="text-danger"> *</span>}
                    </label>
                    <div className="select-container">
                      <Select
                         className="routing_select-box"
                         classNamePrefix="react-select"
                         components={{ SingleValue: CustomSingleValue }}
                        options={routingNames.map(route => ({
                          value: String(route.RUTL_ID),
                          label: route.RUTL_Name
                        }))}
                        value={
                          routingNames.find(route => String(route.RUTL_ID) === selectedRouting)
                            ? {
                              value: String(selectedRouting),
                              label: routingNames.find(route => String(route.RUTL_ID) === selectedRouting)?.RUTL_Name
                            }
                            : null
                        }
                        onChange={handleRoutingChange}
                        placeholder="--Select--"
                        isDisabled={isRoutingLocationDisabled()}
                        onMenuOpen={() => handleSelectOpen('Routing')}
                        onMenuClose={handleSelectClose}
                        maxMenuHeight={"120px"}
                      />

                      <div className="icon-container_list myList">
                        <i>
                          {isSelectOpen === 'Routing' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                        </i>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-1">
                    <Link to={`/dashboard/rm`} >
                      <img src={add} alt="Add All Icon"
                        title='Create Route'
                        style={{
                          width: '19px',
                          height: '19px',
                          marginTop: '41px',
                          filter: 'brightness(0.4)'
                          // marginLeft: '-10px'
                        }} />
                    </Link>
                  </div>
                </div>

                <div className="ms-4 col-md-4 mt-2">
                  <label className="form-label">
                    SCP Name {scpnameempty && <span className="text-danger"> *</span>}
                  </label>
                  <div className="select-container">
                    <Select
                      className="routing_select-box"
                      classNamePrefix="react-select"
                      options={scpNames.map(scp => ({
                        value: String(scp.id),
                        label: scp.name
                      }))}
                      value={
                        scpNames.find(scp => String(scp.id) === selectedScpIdForOrder || String(scp.id) === selectedScpName)
                          ? {
                            value: String(selectedScpIdForOrder || selectedScpName),
                            label: scpNames.find(scp => String(scp.id) === (selectedScpIdForOrder || selectedScpName))?.name
                          }
                          : null
                      }
                      onChange={handleScpNameChange}
                      placeholder="--Select--"
                      isDisabled={scpNameDisabled}
                      onMenuOpen={() => handleSelectOpen('SCP')}
                      onMenuClose={handleSelectClose}
                      maxMenuHeight={"120px"}
                      components={{ SingleValue: CustomSingleValue }}
                    />
                    <div className="icon-container_list myList">
                      <i>
                        {isSelectOpen === 'SCP' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                      </i>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 row mt-2">
                  <div className="col-md-11">
                    <label className="form-label">
                      Order Number {ordernoempty && <span className="text-danger"> *</span>}
                    </label>
                    <div className="select-container">
                      <Select
                         className="routing_select-box"
                         classNamePrefix="react-select"
                         components={{ SingleValue: CustomSingleValue }}
                        options={orderNumbers.map(order => ({
                          value: order.orderNumber,
                          label: order.orderNumber
                        }))}
                        value={
                          selectedOrder
                            ? { value: selectedOrder, label: selectedOrder }
                            : null
                        }
                        onChange={handleOrderSelect}
                        placeholder="--Select--"
                        isDisabled={orderNumberDisabled}
                        onMenuOpen={() => handleSelectOpen('Order')}
                        onMenuClose={handleSelectClose}
                        maxMenuHeight={"120px"}
                      />

                      <div className="icon-container_list myList">
                        <i>
                          {isSelectOpen === 'Order' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                        </i>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-1">
                    <MdPlaylistAdd
                      onClick={handleAddAllButtonClick}
                      title="Add All"
                      style={{
                        fontSize: "28px",
                        marginTop: "38px",  // adjust for visual alignment
                        cursor: "pointer"
                      }}
                    />
                  </div>


                </div>

                <div className='commentContainer mt-2'>
                  <div className="col-md-4">
                    <label htmlFor="returnComment">Add Comment </label>
                    <textarea
                      id="returnComment"
                      name="returnComment"
                      value={comment}
                      onChange={handleCommentChange}
                      rows="3"
                      style={{
                        border: '1px solid #ced4da',
                        padding: '10px',
                        width: '96%',
                        fontSize: '16px',
                        resize: 'none',  // Keep this if you want to prevent resizing
                        overflow: 'auto',  // Enable scrollbars when content overflows
                        transition: 'height 0.3s',
                        borderRadius: "5px",
                        outline: "none"
                      }}
                      placeholder="Enter your comment..."
                    />
                  </div>
                  {/* </div> */}
                  {/* Add Button */}
                  <div className="mb-4 text-center">
                    <button type="button" onClick={handleAddButtonClick} className="shipmentOutCreation_add_btn">ADD</button>
                  </div>
                </div>
              </div>


              {/* Table */}
              {tableData.length > 0 && (
                <div className="table-responsive">
                  <table className="tableClass">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>SCP Name</th>
                        <th>Order Number</th>
                        <th>Product Name</th>
                        <th>Product Code</th>
                        <th>Available Quantity</th>
                        <th>Ordered Quantity</th>
                        <th>Pending Quantity</th>
                        <th>Volume</th>
                        <th>Ship Quantity</th>

                        <th>Action</th>
                        <th style={{ display: 'none' }}>Original Pending Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((row, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{row.scpName}</td>
                          <td>{row.orderNumber}</td>
                          <td>{row.productName}</td>
                          <td>{row.productCode}</td>
                          <td>{row.AvailableQty}</td>
                          <td>{row.SHPD_OrderQty}</td>

                          <td>{row.orderedQty}</td>
                          <td>{row.volume}</td>
                          <td>
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              name={`shipQty${index}`}
                              value={row.shipQty === 0 ? '' : row.shipQty}
                              onChange={(e) => {
                                const rawValue = e.target.value;
                                const sanitizedValue = rawValue.replace(/^0+(?!$)/, '');

                                if (sanitizedValue === '' || /^\d+$/.test(sanitizedValue)) {
                                  handleShipQtyChange(index, sanitizedValue);
                                }
                              }}

                            />

                            {shipQtyErrors[index] && <div className="text-danger">{shipQtyErrors[index]}</div>}
                          </td>
                          <td>
                            <img
                              title='Remove'
                              src={Icon5}
                              onClick={() => showConfirmDialog(index)}
                              className="delete_btn"
                              alt="suspend"
                            // style={{ marginLeft: '6px' }}
                            />
                          </td>
                          <td style={{ display: 'none' }}>{row.originalPendingQty}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {showConfirmation && (
                <div className="popup_overlay">
                  <div className="resetpopup">
                    <h1>:: User Confirmation ::</h1>
                    <h4>Are you sure you want to remove this row ?</h4>
                    <div className="popup_btn_container">
                      <button className="yes_btn " onClick={handleConfirmedRemoval}>
                        YES
                      </button>
                      <button className="no_btn " onClick={hideConfirmDialog}>
                        NO
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <Modal
                show={showDriverModal}
                backdrop="static"
                onHide={handleCloseModal}
                keyboard={false}
                centered
                style={{
                  backdropFilter: 'blur(3px)',
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                }}
              >
                <Modal.Header closeButton>
                  <Modal.Title style={{ fontSize: '20px', fontWeight: 'bold' }}>
                    Driver Details
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <div className="emailModal">

                    {/* ---------------- NAME ---------------- */}
                    <label>
                      Driver Name
                      {driverErrors.name && <span className="text-danger"> *</span>}
                    </label>

                    <input
                      className="esett"
                      type="text"
                      maxLength={100}
                      value={pendingDriverName}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^a-zA-Z ]/g, '');
                        setPendingDriverName(value);

                        // ✅ Clear only if valid
                        if (value.trim() && driverErrors.name) {
                          setDriverErrors(prev => ({ ...prev, name: false }));
                        }
                      }}
                    />

                    {/* ---------------- PHONE ---------------- */}
                    <label style={{ width: '100%' }}>
                      Driver Phone Number
                      {driverErrors.contact &&
                        <span className="text-danger">{driverErrors.message}</span>}
                    </label>

                    <PhoneInput
                      className="phone-input-custom"
                      dropdownClass="phone-dropdown-scroll"
                      key={phoneNumberCountry + '-' + resetCounter}
                      country={phoneNumberToCountryCode(phoneNumberCountry) || 'in'}
                      value={pendingDriverContact}
                      onlyCountries={allowedCountries}
                      countryCodeEditable={false}
                      inputClass="esett"
                      autoComplete="off"

                      onChange={(value, countryData) => {
                        const newDialCode = countryData?.dialCode || '91';
                        const maxLength = phoneLengthMapping[newDialCode] || 10;

                        let digits = value.replace(/\D/g, "");

                        if (digits.startsWith(newDialCode)) {
                          digits = digits.slice(newDialCode.length);
                        }

                        let local = digits.slice(0, maxLength);
                        const finalValue = newDialCode + local;

                        setPendingDriverContact(finalValue);

                        /* -------- VALIDITY CHECK -------- */
                        let isValid = true;

                        if (!local.length) isValid = false;
                        else if (local.startsWith("0")) isValid = false;
                        else if (local.length < maxLength) isValid = false;

                        // ✅ Clear only if valid
                        if (isValid && driverErrors.contact) {
                          setDriverErrors(prev => ({
                            ...prev,
                            contact: false,
                            message: ""
                          }));
                        }

                        prevCountryRef.current = newDialCode;
                      }}

                      onCountryChange={(country) => {
                        setPhoneNumberCountry(country.dialCode);
                        setPendingDriverContact(country.dialCode);
                        prevCountryRef.current = country.dialCode;
                      }}
                    />

                  </div>
                </Modal.Body>

                {/* ---------------- OK BUTTON ---------------- */}
                <Modal.Footer style={{ justifyContent: 'center' }}>
                  <button
                    className="add_btn"
                    style={{
                      fontWeight: 700,
                      fontSize: "16px",
                      letterSpacing: "0.5px"
                    }}
                    onClick={() => {
                      let hasError = false;

                      const dialCode = prevCountryRef.current || "91";
                      const maxLength = phoneLengthMapping[dialCode] || 10;

                      const digits = pendingDriverContact
                        ?.replace(/\D/g, "")
                        .slice(dialCode.length) || "";

                      /* ---------- NAME VALIDATION ---------- */
                      if (!pendingDriverName.trim()) {
                        hasError = true;
                        setDriverErrors(prev => ({ ...prev, name: true }));
                      }

                      /* ---------- PHONE VALIDATION ---------- */
                      if (!digits) {
                        hasError = true;
                        setDriverErrors(prev => ({
                          ...prev,
                          contact: true,
                          message: " *"
                        }));
                      }
                      else if (digits.startsWith("0")) {
                        hasError = true;
                        setDriverErrors(prev => ({
                          ...prev,
                          contact: true,
                          message: " Driver Phone Number cannot start with 0"
                        }));
                      }
                      else if (digits.length < maxLength) {
                        hasError = true;
                        setDriverErrors(prev => ({
                          ...prev,
                          contact: true,
                          message: ` Driver Phone Number must be exactly ${maxLength} digits`
                        }));
                      }

                      if (hasError) return;

                      /* ---------- APPLY ---------- */
                      setDriverName(pendingDriverName);
                      setDriverContact(pendingDriverContact);

                      sessionStorage.setItem('driverName', pendingDriverName);
                      sessionStorage.setItem('driverContact', pendingDriverContact);

                      setShowDriverModal(false);
                    }}
                  >
                    OK
                  </button>
                </Modal.Footer>
              </Modal>

              {showconfimationModal && (
                <div className="popup_overlay">
                  <div className="resetpopup">
                    <h1>:: User Confirmation ::</h1>
                    <h4>Are you sure you want to save the Shipment : {pendingShipmentCode} ?</h4>
                    <div className="popup_btn_container">
                      <button
                        className="yes_btn"
                        onClick={() => {
                          setshowconfimationModal(false);
                          handleSubmit(onSubmit)();
                        }}
                      >
                        YES
                      </button>

                      <button
                        className="no_btn"
                        onClick={() => setshowconfimationModal(false)}
                      >
                        NO
                      </button>

                    </div>
                  </div>
                </div>
              )}




            </div>
          </div>
        </div>

        <div className='button-container'>
          <button
            type="button"
            onClick={handleSubmit(validateBeforeConfirm)}
            className="save_btn"
          >
            SAVE
          </button>

          <button type="button" onClick={handleReset} className="reset_btn">RESET</button>
          <Link to={`/shipmentlist`} className="list_btn" type="button">
            LIST
          </Link>

        </div>
      </form>
    </>
  );
};

export default ShipmentForm;

